import {
  associateEventsActions,
  useAppDispatch,
  useGetAssociateEvents,
  useReadAssociateEvent,
  VsAssociateEventType,
} from '@vs-online-only-app/state';
import NewConversationRequestCard from './incoming-conversation/NewConversationRequestCard';
import SuccessBanner, {
  SuccessBannerType,
} from './incoming-conversation/SuccessBanner';
import NewConversationMissedCard from './incoming-conversation/NewConversationMissedCard';
import { NewConversationAlreadyAcceptedCard } from './incoming-conversation/NewConversationAlreadyAcceptedCard';
import { useEffect, useState } from 'react';

const IncomingNewConversation = () => {
  const { data: associateEvents } = useGetAssociateEvents();
  const conversationRequestEvent = associateEvents?.[0];
  const readAssociateEventMutation = useReadAssociateEvent();
  const [lastEventId, setLastEventId] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (conversationRequestEvent?.id === lastEventId) return;
    setLastEventId(conversationRequestEvent?.id || null);
    if (conversationRequestEvent?.type === VsAssociateEventType.ConversationRequest) {
      dispatch(associateEventsActions.setCurrentIncomingConversationRequestEvent(conversationRequestEvent));
    }
  }, [conversationRequestEvent, dispatch, lastEventId]);

  const markEventAsRead = () => {
    if (!conversationRequestEvent || conversationRequestEvent.read) return;
    readAssociateEventMutation.mutate(conversationRequestEvent.id);
  };

  if (!conversationRequestEvent || conversationRequestEvent.read) {
    return null;
  }

  if (
    conversationRequestEvent.type === VsAssociateEventType.ConversationMissed
  ) {
    return (
      <NewConversationMissedCard
        event={conversationRequestEvent}
        onClose={markEventAsRead}
      />
    );
  }

  if (
    conversationRequestEvent.type ===
    VsAssociateEventType.ConversationAlreadyAccepted
  ) {
    return (
      <NewConversationAlreadyAcceptedCard
        event={conversationRequestEvent}
        onClose={markEventAsRead}
      />
    );
  }

  if (
    conversationRequestEvent.type ===
    VsAssociateEventType.ConversationJoinRequestCompleted
  ) {
    return (
      <SuccessBanner
        type={SuccessBannerType.NewConversation}
        conversationId={conversationRequestEvent.conversation.id}
        requesterId={
          conversationRequestEvent.conversation.conversationStarter.id
        }
        onClose={markEventAsRead}
      />
    );
  }

  if (
    conversationRequestEvent.type === VsAssociateEventType.ConversationRequest
  ) {
    return <NewConversationRequestCard event={conversationRequestEvent} />;
  }

  return null;
};

export default IncomingNewConversation;
